import { render, staticRenderFns } from "./NotPaid.vue?vue&type=template&id=f6d95994&scoped=true&"
import script from "./NotPaid.vue?vue&type=script&lang=js&"
export * from "./NotPaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d95994",
  null
  
)

export default component.exports